document.addEventListener('DOMContentLoaded', () => {
  if (window.lucide) window.lucide.createIcons();

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const toast = $('[data-toast]');
  let toastTimer;
  const notify = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 2400);
  };

  const menuButton = $('[data-menu-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    $$('[data-mobile-nav] a').forEach((link) => link.addEventListener('click', () => {
      mobileNav.classList.remove('open');
      menuButton.setAttribute('aria-expanded', 'false');
    }));
  }

  // Keep the static-preview drawer working when the same assets are used outside Shopify.
  const drawer = $('[data-cart-drawer]');
  const overlay = $('[data-overlay]');
  const openDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.add('open'); overlay.classList.add('visible');
    drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll');
  };
  const closeDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.remove('open'); overlay.classList.remove('visible');
    drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll');
  };
  const cartOpen = $('[data-cart-open]');
  if (cartOpen) cartOpen.addEventListener('click', openDrawer);
  const drawerClose = $('[data-drawer-close]');
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  const searchDialog = $('[data-search-dialog]');
  const searchOpen = $('[data-search-open]');
  if (searchDialog && searchOpen) searchOpen.addEventListener('click', () => searchDialog.showModal());
  const searchClose = $('[data-search-close]');
  if (searchDialog && searchClose) searchClose.addEventListener('click', () => searchDialog.close());
  const searchForm = $('[data-search-form]');
  if (searchForm) searchForm.addEventListener('submit', (event) => {
    event.preventDefault();
    const query = new FormData(searchForm).get('q');
    if (!query || !String(query).trim()) return;
    if (searchDialog) searchDialog.close();
    notify(`Searching for “${String(query).trim()}”`);
  });
  $$('.search-tags button').forEach((button) => button.addEventListener('click', () => {
    const input = $('.search-top input');
    if (input) { input.value = button.textContent; input.focus(); }
  }));

  const legacyNewsletter = $('[data-newsletter]');
  if (legacyNewsletter) legacyNewsletter.addEventListener('submit', (event) => {
    event.preventDefault(); legacyNewsletter.reset(); notify('You are subscribed to The NOVA Edit');
  });

  const chatPanel = $('[data-chat-panel]');
  const chatToggle = $('[data-chat-toggle]');
  const setChat = (open) => { if (chatPanel) { chatPanel.classList.toggle('open', open); chatPanel.setAttribute('aria-hidden', String(!open)); } };
  if (chatToggle) chatToggle.addEventListener('click', () => setChat(!chatPanel.classList.contains('open')));
  const chatClose = $('[data-chat-close]');
  if (chatClose) chatClose.addEventListener('click', () => setChat(false));
  const chatForm = $('[data-chat-form]');
  if (chatForm) chatForm.addEventListener('submit', (event) => {
    event.preventDefault();
    const input = $('#chat-input');
    if (!input || !input.value.trim()) return;
    const message = document.createElement('p'); message.className = 'user-message'; message.textContent = input.value.trim();
    const body = $('.chat-body'); if (body) body.append(message); input.value = '';
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer && drawer.classList.contains('open')) closeDrawer();
  });
});
